import { Component } from '@angular/core'
import { MbConstants, poUploadMaxFileSize } from '../../../shared/mb-constants'
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { PoUpload } from '../../../models'
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core'
import { Store } from '@ngrx/store'
import { PoUploadActions } from '../../store/actions'

@Component({
  selector: 'mb-po-upload',
  templateUrl: './po-upload.component.html',
  styleUrls: ['./po-upload.component.scss']
})
export class PoUploadComponent {

  constants = MbConstants
  poUploadMaxFileSize = poUploadMaxFileSize
  maxFileSizeExceeded: boolean = false
  poUpload: PoUpload = {}
  poUploadForm = new UntypedFormGroup({
    firstName: new UntypedFormControl(this.poUpload?.firstName, [Validators.required]),
    lastName: new UntypedFormControl(this.poUpload?.lastName, [Validators.required]),
    email: new UntypedFormControl(this.poUpload?.email, [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,63}$')]),
    phoneNumber: new UntypedFormControl(this.poUpload?.phoneNumber, [Validators.required]),
    poFile: new UntypedFormControl(this.poUpload?.file, [Validators.required, this.extensionValidator(), this.sizeValidator()]),
    termsOfUse: new UntypedFormControl(this.poUpload?.termsOfUse, [Validators.requiredTrue]),
  })

  constructor (protected globalMessageService: GlobalMessageService,
               protected store: Store<PoUpload>,
               protected translation: TranslationService) { }

  extensionValidator () {
    return (control: AbstractControl) => {
      if (control.value) {
        const isPdfExtension = control.value.split('.')?.pop()?.toLowerCase() === MbConstants.PDF_EXTENSION
        return !isPdfExtension ? { pdfFileExtension: this.translation.translate('mbcommon.formValidationErrors.pdfFileExtension') } : null
      }
      return null
    }
  }

  sizeValidator () {
    return () => this.maxFileSizeExceeded ? { maxUploadSizeExceeded: this.translation.translate('mbcommon.formValidationErrors.maxUploadSizeExceeded') } : null
  }

  submitPurchaseOrder () {
    if (!this.poUploadForm.valid) {
      this.poUploadForm.markAllAsTouched()
      this.globalMessageService.add({ key: 'poUploadForm.mandatoryMissingError' }, GlobalMessageType.MSG_TYPE_ERROR)
    } else {
      this.convertPoUploadForm2Model()
      this.store.dispatch(new PoUploadActions.PurchaseOrderUpload({ form: this.poUpload }))
    }
  }

  uploadFile (event: any) {
    this.maxFileSizeExceeded = event?.target?.files?.[0]?.size > this.poUploadMaxFileSize
    this.poUpload = {
      ...this.poUpload,
      file: event?.target?.files?.[0]
    }
    this.poUploadForm.get('poFile')?.updateValueAndValidity()
  }

  convertPoUploadForm2Model () {
    this.poUpload = {
      ...this.poUpload,
      firstName: this.poUploadForm?.get(this.constants.FIRST_NAME_CODE)?.value,
      lastName: this.poUploadForm?.get(this.constants.LAST_NAME_CODE)?.value,
      email: this.poUploadForm?.get(this.constants.EMAIL_CODE)?.value,
      phoneNumber: this.poUploadForm?.get(this.constants.PHONE_NUMBER_CODE)?.value,
      termsOfUse: this.poUploadForm?.get(this.constants.TERMS_OF_USE)?.value,
    }
  }

}
